import * as React from 'react';

import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Page } from '../subs/Page';
import { Link, useParams } from 'react-router-dom';
import { Typography } from '@mui/material';
import { AlertProps } from '@mui/material/Alert';
import { useSnackbar } from '../../contexts/SnackBarContext';
import { UserContext } from "../UserProvider";
import { httpGet } from '../Web';
import { SuccessFailureIndicator } from '../subs/SuccessFailureIndicator';
import { PageSection } from '../subs/PageSection';
import { getCurrentWSUser } from '../types/Workshop';
import { WorkshopUser } from '../types/WorkshopUser';
import { isGlobalAdmin } from '../types/User';

export const WSUsers = () => {
    const { wsId: workshopID } = useParams();
    const user = React.useContext(UserContext);
    //const workshopID = useLocation().state.id;
    const [wsUsersData, setWsUsers] = React.useState<WorkshopUser[]>([]);
    const [isWSUser, setIsWSUser] = React.useState(false);
    const [globalAdmin, setIsGlobalAdmin] = React.useState(false);
    const { showSnackbar } = useSnackbar();

    const showUserFeedback = React.useCallback((msg: string | null, severity: AlertProps['severity'] = 'error') => {
        msg && showSnackbar(msg, severity);
    }, [showSnackbar]);

    React.useEffect(()=> {
        fetch();

        async function fetch() {
            if (workshopID === undefined) return;
            let query = `api/workshop/user/${workshopID}`;
            console.log('query: ', query, " length: ", query.length);

            let isGlobalAdminResponse = await isGlobalAdmin(user.user.id!!, new AbortController());
            let isWSUserLoc = false;

            setIsGlobalAdmin(isGlobalAdminResponse);

            if (false === isGlobalAdminResponse) {
                let currentWSUser = await getCurrentWSUser(Number(workshopID), new AbortController());

                if (currentWSUser?.errorCode) {
                    setIsWSUser(false);
                }
                else {
                    const currentUser: WorkshopUser = currentWSUser.result;
                    isWSUserLoc = currentUser.userId === user.user.id;
                    setIsWSUser(isWSUserLoc);
                }
            }
            let response = await httpGet(query, new AbortController());
            console.log(response);
            if(response?.errorCode) {
                setWsUsers([]);
                showUserFeedback(response);
            }
            else {
                let wsUsers: WorkshopUser[] = response?.result;
                if (!isGlobalAdminResponse && !isWSUserLoc) {
                    // reduce the wsUsers list to unique company names
                    const unique = [...new Set(wsUsers.map(item => item.companyName))];
                    // build a new array of objects with unique company names
                    wsUsers = unique.map(companyName => {
                        return { companyName: companyName, id: companyName, name: "- -", email: "", isWorkshopAdmin: false, userId: 0, workshopId:0 } as WorkshopUser;
                    });
                }
                setWsUsers(wsUsers);
            }
        }
    }, [workshopID, showUserFeedback, user.user.id])

    const cols: GridColDef[] = [{
        field: 'companyName',
        headerName: "Company",
        flex: 3,
        renderCell: (params) => <Typography variant='bold'>{params.row.companyName}</Typography>
    },
    {
        field: 'FirstName',
        headerName: "First name",
        flex: 2,
        valueGetter: (value, row) => {
            return row.name.slice(0, row.name.indexOf(" "));
        },
    },
    {
        field: 'LastName',
        headerName: "Last name",
        flex: 2,
        valueGetter: (value, row) => {
            return row.name.slice(row.name.indexOf(" "), row.name.length);
        },
    },
    {
        field: 'email',
        headerName: "Email",
        flex: 4,
        renderCell: (params) => <Link to={`mailto:${params.row.email}`}>{params.row.email}</Link>
    },
    {
        field: 'Registered',
        headerName: "Registered",
        flex: 1,
        renderCell: (params) => { return <SuccessFailureIndicator success={params.row.status >= 1} /> },
        sortable: false,
    },
    {
        field: 'Confirmed',
        headerName: "Confirmed",
        flex: 1,
        renderCell: (params) => { return <SuccessFailureIndicator success={params.row.status === 2} /> },
        sortable: false,
    }
    ]


    const viewerCols: GridColDef[] = [{
        field: 'companyName',
        headerName: "Company",
        flex: 3,
        renderCell: (params) => <Typography variant='bold'>{params.row.companyName}</Typography>
    }
    ]

    const userCols: GridColDef[] = [{
            field: 'companyName',
            headerName: "Company",
            flex: 3,
            renderCell: (params) => <Typography variant='bold'>{params.row.companyName}</Typography>
        },
        {
            field: 'FirstName',
            headerName: "First name",
            flex: 2,
            valueGetter: (value, row) => {
                return row.name.slice(0, row.name.indexOf(" "));
            },
        },
        {
            field: 'LastName',
            headerName: "Last name",
            flex: 2,
            valueGetter: (value, row) => {
                return row.name.slice(row.name.indexOf(" "), row.name.length);
            },
        }
    ]

    return <Page heading={"The following users have registered for this workshop."} backButton breadcrumbs>{[
            <PageSection>
            {[<div style={{ display: 'flex', flexDirection: 'column' }}>
                <DataGrid columns={globalAdmin ? cols : isWSUser ? userCols : viewerCols} 
                          rows={wsUsersData}
                            hideFooter
                            disableColumnMenu
                            showCellVerticalBorder
                    getRowClassName={(params) => params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'}
                />
            </div>]}
            </PageSection>
            ]}
        </Page>
}